import { render, staticRenderFns } from "./backup_mold.vue?vue&type=template&id=3b2a10f5&scoped=true&"
import script from "./backup_mold.vue?vue&type=script&lang=js&"
export * from "./backup_mold.vue?vue&type=script&lang=js&"
import style0 from "./backup_mold.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./backup_mold.vue?vue&type=style&index=1&id=3b2a10f5&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a10f5",
  null
  
)

export default component.exports